import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { MAX_LENGTH_POLL_OPTION, MAX_LENGTH_POLL_TITLE } from "../../config";
import { IconAddPoll, IconClose, PollSolid } from "../../icons/svg";
import Helpers from "../../lib/helpers";
import GroupService from "../../services/group";
import { Topic } from "../../tinode/topic";
import Switch from "../switch.jsx";

class CreatePoll extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getBlankState();

    this.handleCreatePoll = this.handleCreatePoll.bind(this);
    this.handleSwichAddOption = this.handleSwichAddOption.bind(this);
    this.handleSwichMultiChoice = this.handleSwichMultiChoice.bind(this);
    this.handleChangeTitle = this.handleChangeTitle.bind(this);
    this.validate = this.validate.bind(this);
  }

  getBlankState() {
    return {
      title: '',
      options: [
        '',
        ''
      ],
      multiChoice: true,
      addOption: true,
      errorOption: [
        '',
        ''
      ],
      disable: false
    }
  }

  handleSwichMultiChoice() {
    this.setState({
      multiChoice: !this.state.multiChoice
    });
  }

  handleSwichAddOption() {
    this.setState({
      addOption: !this.state.addOption
    });
  }

  handleChangeTitle(e) {
    let s = e.target.value;
    if (s.length > MAX_LENGTH_POLL_TITLE) {
      return;
    }
    this.setState({
      title: s
    });
  }

  handleChangeOption(e, index) {
    let s = e.target.value;
    let { options } = this.state;
    if (s.length > MAX_LENGTH_POLL_OPTION) {
      return;
    }
    options[index] = s;
    this.setState({
      options: options
    }, () => {
      this.validate();
    });
  }

  handleAddOrRemoveOption(type, index) {
    let { options, errorOption } = this.state;
    const { formatMessage } = this.props.intl;
    switch (type) {
      case 1:
        options.push('');
        errorOption.push('');
        break;
      case 2:
        if (options.length <= 2) {
          Helpers.showErrorToasts(formatMessage({
            id: "dialog_poll_required",
            defaultMessage: "There should be at least 2 options",
          }));
        } else {
          options.splice(index, 1);
          errorOption.splice(index, 1);
        }
        break;
    }
    this.setState({
      options: options
    });
  }

  handleCreatePoll() {
    const { formatMessage } = this.props.intl;
    let { title, options, multiChoice, addOption } = this.state;
    const topic = Topic.getThreadId(this.props.topic);
    const enableAddOption = addOption ? 1 : 0;
    const multipleChoice = multiChoice ? 2 : 1;
    if (!this.validate()) {
      options = options.filter(v => {
        return v.trim() != '';
      })
      GroupService.createVote(topic, title.trim(), enableAddOption, multipleChoice, JSON.stringify(options)).then((res) => {
        if (res.code === 200) {
          let msgPoll = res.data;
          this.props.tinode.createPollMessage(this.props.topic, msgPoll);
          this.props.onClose();
        }
      }).catch((err) => {
        Helpers.showErrorToasts(formatMessage({
          id: "toast_err",
          defaultMessage: "An error occurred. Please try again later"
        }));
      });
    }

  }

  validate() {
    const { formatMessage } = this.props.intl;
    let { options, errorOption } = this.state;
    let error = false;
    errorOption = errorOption.map(v => {
      return '';
    })
    options.map((value, index) => {
      let listIndex = options.reduce(function (a, e, i) {
        if (e == value && value.trim() != '')
          a.push(i);
        return a;
      }, []);
      if (listIndex.length > 1) {
        listIndex.forEach(v => {
          errorOption[v] = formatMessage({
            id: "duplicate_option",
            defaultMessage: "There are duplicated options"
          });
        });
        error = true;
      }
    });
    this.setState({
      errorOption: errorOption,
      disable: error
    });
    return error;
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { title, options, multiChoice, addOption, errorTitle, errorOption, disable } = this.state;
    return (
      <div className="poll">
        <div className="header">
          <button className="back" onClick={this.props.onClose}>
            <FormattedMessage id="dialog_poll_cancel" defaultMessage={"Cancel"} />
          </button>
          <div className="title">
            <FormattedMessage id="dialog_poll_title" defaultMessage={"Tạo khảo sát mới"} />
          </div>
          <button className="done" onClick={this.handleCreatePoll} disabled={disable || title.trim() == ''} >
            <FormattedMessage id="dialog_poll_create" defaultMessage={"Create"} />
          </button>
        </div>
        <div className="content-poll">
          <div className="box-question">
            <div className="title">
              <FormattedMessage id="dialog_poll_question" defaultMessage={"Question"} />
            </div>
            <div className="input-area">
              <textarea
                cols="30"
                rows="10"
                placeholder={formatMessage({
                  id: 'dialog_poll_question_desc',
                  defaultMessage: "Enter survey questions"
                })}
                onChange={this.handleChangeTitle}
                value={title}
              />
              <span>{title.length}/200</span>
            </div>
            <span className="error">{errorTitle}</span>
          </div>
          <div className="box-option">
            <div className="title">
              <FormattedMessage id="dialog_poll_option" defaultMessage={"Option"} />
            </div>
            <div className="list-option">
              {options.map((value, index) => {
                return (
                  <div className="input-item" key={index}>
                    <input type="text"
                      placeholder={formatMessage({
                        id: 'dialog_poll_option_number',
                        defaultMessage: "Option {number}"
                      }, { number: index + 1 })}
                      value={value}
                      onChange={(e) => this.handleChangeOption(e, index)}
                    />
                    <div className="icon-close" onClick={() => this.handleAddOrRemoveOption(2, index)}>
                      <IconClose />
                    </div>
                    <span className="error">{errorOption[index]}</span>
                  </div>)
              })}
            </div>
            <button className="add-option" onClick={() => this.handleAddOrRemoveOption(1)} disabled={disable}>
              <div className="icon-add">
                <IconAddPoll />
              </div>
              <div className="text">
                <FormattedMessage id="dialog_poll_add_option" defaultMessage={"Add option"} />
              </div>
            </button>
          </div>
          <div className="box-config-poll">
            <div className="title">
              <FormattedMessage id="dialog_poll_config_title" defaultMessage={"Set up a survey"} />
            </div>
            <div className="box-desc-config">
              <PollSolid />
              <div className="desc">
                <FormattedMessage
                  id="dialog_poll_config_desc"
                  defaultMessage={"Please note that you won't be able to change this setting once the survey has been published"} />
              </div>
            </div>
            <div className="config border-config">
              <div className="left">
                <div className="name">
                  <FormattedMessage id="dialog_poll_config_multiple_option" defaultMessage={"Allows you to choose multiple options"} />
                </div>
                <div className="desc">
                  <FormattedMessage id="dialog_poll_config_multiple_option_desc" defaultMessage={"Each person can vote for multiple options"} />
                </div>
              </div>
              <div className="right">
                <Switch onClick={this.handleSwichMultiChoice} status={multiChoice} />
              </div>
            </div>
            <div className="config">
              <div className="left">
                <div className="name">
                  <FormattedMessage id="dialog_poll_config_add_option" defaultMessage={"Allows additional options"} />
                </div>
                <div className="desc">
                  <FormattedMessage id="dialog_poll_config_add_option_desc" defaultMessage={"Allow people to add their own options"} />
                </div>
              </div>
              <div className="right">
                <Switch onClick={this.handleSwichAddOption} status={addOption} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(CreatePoll)